module.exports = __webpack_public_path__ + "static/media/Coaches.3147139c.svg";